// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__5WUHO","requiredAsterisk":"Info_requiredAsterisk__I5QqQ"};